import { ELoginCompletionMethod } from '@aca-new/app/pages/login/shared/models/enums/login-completion-method.enum';
import { ELoginType } from '@aca-new/app/shared/models/enums/login-type.enum';

export type TFreshLoginCompletionMethod = ELoginCompletionMethod.EMAIL_OTP | ELoginCompletionMethod.PASSWORD | ELoginCompletionMethod.BACK_OFFICE;

export type TRestoreLoginCompletionMethod =
  | ELoginCompletionMethod.RESTORE_EMAIL_OTP
  | ELoginCompletionMethod.RESTORE_PASSWORD
  | ELoginCompletionMethod.RESTORE_BACK_OFFICE
  | ELoginCompletionMethod.RESTORE_NONE;

export const LOGIN_SUCCESS_EVENT_LABEL_BY_METHOD: Record<TFreshLoginCompletionMethod, string> = {
  [ELoginCompletionMethod.EMAIL_OTP]: 'Login Success - Email OTP',
  [ELoginCompletionMethod.PASSWORD]: 'Login Success - Password',
  [ELoginCompletionMethod.BACK_OFFICE]: 'Login Success - Back Office',
};

export const RESTORE_LOGIN_SUCCESS_EVENT_LABEL_BY_METHOD: Record<TRestoreLoginCompletionMethod, string> = {
  [ELoginCompletionMethod.RESTORE_EMAIL_OTP]: 'Login Success - Restore Email OTP',
  [ELoginCompletionMethod.RESTORE_PASSWORD]: 'Login Success - Restore Password',
  [ELoginCompletionMethod.RESTORE_BACK_OFFICE]: 'Login Success - Restore Back Office',
  [ELoginCompletionMethod.RESTORE_NONE]: 'Login Success - Restore Unknown',
};

/** Maps persisted `loginType` cookie (backend token field) to fresh-login analytics method. */
export const LOGIN_TYPE_TO_FRESH_LOGIN_METHOD: Record<ELoginType, TFreshLoginCompletionMethod> = {
  [ELoginType.LOGIN_OTP]: ELoginCompletionMethod.EMAIL_OTP,
  [ELoginType.LOGIN_FROM_SSO]: ELoginCompletionMethod.BACK_OFFICE,
  [ELoginType.LOGIN_WITH_PWD]: ELoginCompletionMethod.PASSWORD,
};

/** Maps persisted `loginType` cookie to restore login_success analytics method. */
export const LOGIN_TYPE_TO_RESTORE_LOGIN_METHOD: Record<ELoginType, Exclude<TRestoreLoginCompletionMethod, ELoginCompletionMethod.RESTORE_NONE>> = {
  [ELoginType.LOGIN_OTP]: ELoginCompletionMethod.RESTORE_EMAIL_OTP,
  [ELoginType.LOGIN_FROM_SSO]: ELoginCompletionMethod.RESTORE_BACK_OFFICE,
  [ELoginType.LOGIN_WITH_PWD]: ELoginCompletionMethod.RESTORE_PASSWORD,
};
